import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetojyotilingadarshanpackage() {



  const cardData = {




keyword: "Pune to Jyotirlinga Darshan Package",

headingDescription: "Garud Cab Service provides comfortable and reliable Pune to Jyotirlinga Darshan Package for devotees, families, senior citizens, couples, and groups planning a spiritual journey across Maharashtra. We offer chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, Tempo Traveller, and premium vehicles for customized temple tours, one-day pilgrimages, multi-day Darshan packages, and round-trip journeys. With experienced drivers, clean and well-maintained vehicles, flexible pickup locations, spacious luggage facilities, transparent pricing, and 24/7 customer assistance, we make long-distance religious travel convenient and peaceful. Whether you are planning a single Jyotirlinga visit or a multi-temple pilgrimage covering important Shiva temples, Garud Cab Service provides comfortable transportation according to your preferred itinerary.",

topPlaces: [
  {
    title: "Trimbakeshwar",
    description: "Trimbakeshwar is an important pilgrimage destination near Nashik and is home to the revered Trimbakeshwar Jyotirlinga Temple dedicated to Lord Shiva. The temple is situated near the Brahmagiri hills and attracts devotees throughout the year. Travelers from Pune can include Trimbakeshwar in a customized Jyotirlinga Darshan package with comfortable chauffeur-driven transportation."
  },
  {
    title: "Bhimashankar",
    description: "Bhimashankar is a sacred pilgrimage destination in the Sahyadri ranges and is home to the famous Bhimashankar Jyotirlinga Temple. The surrounding hills and forests provide a peaceful setting for devotees and nature lovers. Garud Cab Service offers comfortable vehicles for families and groups traveling from Pune for Darshan and nearby sightseeing."
  },
  {
    title: "Grishneshwar",
    description: "Grishneshwar is an important Shiva pilgrimage destination located near the historic Ellora Caves and is traditionally counted among the twelve Jyotirlingas. The temple features traditional architecture and attracts devotees from across India. Travelers can conveniently include Grishneshwar in a multi-day Jyotirlinga Darshan package from Pune."
  },
  {
    title: "Aundha Nagnath",
    description: "Aundha Nagnath is a significant religious destination in Maharashtra associated with the Jyotirlinga tradition and is dedicated to Lord Shiva. The ancient temple attracts devotees throughout the year and offers a peaceful spiritual atmosphere. A private cab from Pune allows families and groups to travel comfortably while following a customized pilgrimage route."
  },
  {
    title: "Parli Vaijnath",
    description: "Parli Vaijnath is a revered Lord Shiva temple in Maharashtra and an important destination for devotees following the Jyotirlinga pilgrimage tradition. The temple attracts visitors from different regions for religious ceremonies and Darshan. Garud Cab Service can arrange a spacious vehicle for families and groups traveling from Pune on a multi-day temple tour."
  },
  {
    title: "Shirdi",
    description: "Shirdi is one of Maharashtra's most visited pilgrimage destinations and is home to the revered Sai Baba Temple. Devotees can visit the Samadhi Mandir and other important spiritual locations in the town. Shirdi can be added to an extended Jyotirlinga Darshan itinerary for travelers who want to combine multiple religious destinations in one road journey."
  },
  {
    title: "Shani Shingnapur",
    description: "Shani Shingnapur is a well-known spiritual destination in Maharashtra dedicated to Lord Shani and is frequently visited by devotees traveling through the region. The unique open-air shrine and religious traditions make it an interesting pilgrimage stop. Travelers can include Shani Shingnapur in a customized temple tour along with other Maharashtra religious destinations."
  },
  {
    title: "Nashik",
    description: "Nashik is a major pilgrimage and cultural city with several important temples, sacred sites, and access to Trimbakeshwar. The Panchavati area, Godavari ghats, and historic temples provide additional religious experiences for visitors. A private cab allows devotees to explore Nashik comfortably while continuing their Jyotirlinga Darshan journey."
  },
  {
    title: "Ellora Caves",
    description: "Ellora Caves are a UNESCO World Heritage Site located close to Grishneshwar and feature remarkable Buddhist, Hindu, and Jain rock-cut monuments. The Kailasa Temple is particularly notable for its extraordinary ancient craftsmanship. Devotees traveling on a Jyotirlinga package can add Ellora sightseeing to their itinerary for a combination of spiritual and historical exploration."
  },
  {
    title: "Ujjain",
    description: "Ujjain is a major Hindu pilgrimage city in Madhya Pradesh and is home to the revered Mahakaleshwar Jyotirlinga Temple. The city also offers several important religious attractions along the banks of the Shipra River. Travelers from Pune planning an extended Jyotirlinga journey can include Ujjain as part of a customized multi-state pilgrimage route."
  }
],



"services": [
{
"name": "Panch Jyotirlinga Tour from Pune",
"description": "Book a Panch Jyotirlinga Tour from Pune for a comfortable and convenient pilgrimage journey covering the major Jyotirlinga temples with a professional chauffeur and well-maintained AC vehicle. Choose from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, and premium cab options for family groups, senior citizens, devotees, and multi-day religious travel."
},
{
"name": "Panch Jyotirlinga Darshan from Pune",
"description": "Plan Panch Jyotirlinga Darshan from Pune with a private chauffeur-driven cab designed for comfortable temple visits and long-distance travel. Enjoy flexible pickup arrangements, spacious seating, luggage space, and experienced drivers while traveling with family, friends, or religious groups on a customized pilgrimage itinerary."
},
{
"name": "Pune Jyotirlinga Darshan",
"description": "Book Pune Jyotirlinga Darshan cab service for a convenient pilgrimage journey from Pune to important Jyotirlinga temples across Maharashtra. Travel in clean AC vehicles with professional chauffeurs and select a suitable Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, or SUV according to your group size, luggage, and journey duration."
},
{
"name": "3 Jyotirlinga in Maharashtra Tour Package",
"description": "Choose a 3 Jyotirlinga in Maharashtra Tour Package for a well-planned religious journey covering three important Jyotirlinga temples in the state. Enjoy private chauffeur-driven transportation, comfortable AC vehicles, flexible sightseeing schedules, and convenient temple-to-temple travel for families, devotees, senior citizens, and groups."
},
{
"name": "3 Jyotirlinga in Maharashtra Tour Package from Pune",
"description": "Book a 3 Jyotirlinga in Maharashtra Tour Package from Pune for convenient multi-temple pilgrimage travel with private cab transportation. Professional chauffeurs, comfortable seating, spacious luggage capacity, and flexible itinerary options make the journey suitable for families and groups visiting Bhimashankar, Trimbakeshwar, Grishneshwar, or other selected Jyotirlinga destinations."
},
{
"name": "Maharashtra 5 Jyotirlinga Darshan",
"description": "Arrange Maharashtra 5 Jyotirlinga Darshan with a private outstation cab for a comfortable and organized pilgrimage experience. Travel between temples with experienced chauffeurs, air-conditioned vehicles, flexible stopovers, and suitable vehicle options including Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, and SUV for families and larger groups."
},
{
"name": "Pune to Bhimashankar Cab",
"description": "Book Pune to Bhimashankar Cab for a comfortable pilgrimage journey to the Bhimashankar Jyotirlinga Temple. Enjoy private AC transportation, experienced chauffeurs, convenient pickup from your preferred Pune location, and vehicle choices such as Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, and SUV for individuals, families, and devotees."
},
{
"name": "Pune to Trimbakeshwar Cab",
"description": "Reserve Pune to Trimbakeshwar Cab for a convenient and private journey to Trimbakeshwar Jyotirlinga near Nashik. Professional chauffeurs provide comfortable AC transportation with flexible pickup and travel arrangements, making the service suitable for family pilgrimage trips, senior citizens, devotees, and groups planning temple visits."
},
{
"name": "Pune to Grishneshwar Jyotirlinga Cab",
"description": "Hire Pune to Grishneshwar Jyotirlinga Cab for comfortable pilgrimage travel from Pune to the Grishneshwar temple near Ellora. Choose from spacious and well-maintained AC vehicles with professional chauffeurs for family trips, religious tours, sightseeing, and multi-day Jyotirlinga darshan itineraries."
},
{
"name": "Pune to Aundha Nagnath Cab Service",
"description": "Book Pune to Aundha Nagnath Cab Service for a private and comfortable pilgrimage journey to Aundha Nagnath Temple. Travel with experienced chauffeurs in clean AC vehicles and select Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, or SUV options according to passenger count, luggage requirements, and trip duration."
},
{
"name": "Pune to Parli Vaijnath Cab Service",
"description": "Choose Pune to Parli Vaijnath Cab Service for convenient long-distance pilgrimage transportation from Pune to Parli Vaijnath Jyotirlinga. Enjoy professional chauffeur service, comfortable AC interiors, spacious luggage capacity, and flexible one-way or round-trip arrangements for devotees, families, senior citizens, and religious groups."
},
{
"name": "Cheapest Jyotirlinga Darshan Cab Booking",
"description": "Book a Cheapest Jyotirlinga Darshan Cab for budget-conscious pilgrimage travel from Pune while maintaining comfort and convenience. Select an economical Sedan, Swift Dzire, Ertiga, or larger vehicle according to your group size and itinerary, with professional chauffeurs and flexible arrangements for single or multiple Jyotirlinga temple visits."
},
{
"name": "Jyotirlinga Darshan Package from Pune",
"description": "Reserve a Jyotirlinga Darshan Package from Pune for a convenient chauffeur-driven pilgrimage covering selected Jyotirlinga temples across Maharashtra. Enjoy comfortable AC vehicles, experienced drivers, flexible pickup locations, planned temple visits, and vehicle options suitable for families, devotees, senior citizens, and groups traveling for multiple days."
},
{
"name": "Jyotirlinga Darshan Tour Package",
"description": "Choose a Jyotirlinga Darshan Tour Package for a private and comfortable religious journey with flexible temple visit schedules and chauffeur-driven transportation. Travel in well-maintained AC vehicles with spacious seating and luggage capacity while planning one or multiple temple visits according to your preferred pilgrimage itinerary."
},
{
"name": "Innova Crysta for Jyotirlinga Darshan",
"description": "Hire Innova Crysta for Jyotirlinga Darshan when you need a spacious and premium vehicle for a family pilgrimage or group religious tour. Enjoy comfortable seating, ample luggage space, air-conditioned interiors, and professional chauffeur service, making it suitable for multi-day Jyotirlinga journeys from Pune with family and senior passengers."
}
],
"tableData": [
["Panch Jyotirlinga Tour from Pune", "Panch Jyotirlinga Darshan from Pune"],
["Pune Jyotirlinga Darshan", "3 Jyotirlinga in Maharashtra Tour Package"],
["3 Jyotirlinga in Maharashtra Tour Package from Pune", "Maharashtra 5 Jyotirlinga Darshan"],
["Pune to Bhimashankar Cab", "Pune to Trimbakeshwar Cab"],
["Pune to Grishneshwar Jyotirlinga Cab", "Pune to Aundha Nagnath Cab Service"],
["Pune to Parli Vaijnath Cab Service", "Cheapest Jyotirlinga Darshan Cab Booking"],
["Jyotirlinga Darshan Package from Pune", "Jyotirlinga Darshan Tour Package"],
["Innova Crysta for Jyotirlinga Darshan", ""]
],



whychoose: [
  {
    WhyChooseheading: "Pune to Jyotirlinga Darshan Package by Private Cab",
    WhyChoosedescription: "Garud Cab Service offers customized Jyotirlinga Darshan travel packages from Pune for devotees, families, senior citizens, and religious groups seeking convenient private transportation for a temple pilgrimage."
  },
  {
    WhyChooseheading: "Pilgrimage Plans Designed Around Your Schedule",
    WhyChoosedescription: "Temple visits can require careful planning, so the journey can be organized around your preferred travel dates, darshan timings, overnight stays, meal breaks, and return schedule."
  },
  {
    WhyChooseheading: "Suitable for Different Jyotirlinga Routes",
    WhyChoosedescription: "Choose a pilgrimage plan based on the Jyotirlinga temples you want to visit. The itinerary can be discussed according to your selected destinations, available days, and overall travel preferences."
  },
  {
    WhyChooseheading: "Comfortable Travel for Senior Citizens",
    WhyChoosedescription: "Private transportation provides greater flexibility for elderly devotees by allowing planned rest stops, convenient boarding points, luggage space, and a less rushed travel experience."
  },
  {
    WhyChooseheading: "Family-Friendly Religious Travel",
    WhyChoosedescription: "Families can travel together in a dedicated vehicle without arranging separate transportation between pilgrimage destinations, making the journey easier to coordinate for children and senior members."
  },
  {
    WhyChooseheading: "Flexible Multi-Day Package Options",
    WhyChoosedescription: "Depending on the selected temples and route, the package can be planned over multiple days with suitable stops for accommodation, darshan, meals, rest, and additional religious visits."
  },
  {
    WhyChooseheading: "Convenient Pune Pickup and Return",
    WhyChoosedescription: "Start your pilgrimage from your preferred Pune location and arrange the return journey according to your package itinerary, making the overall temple tour easier to manage."
  },
  {
    WhyChooseheading: "Plan Your Darshan Package with Garud",
    WhyChoosedescription: "Share your preferred Jyotirlinga temples, travel dates, number of devotees, Pune pickup point, vehicle requirement, and expected trip duration to create a suitable pilgrimage travel plan."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Pune to Jyotirlinga Darshan Packages?",
    answer: "Yes, Garud Cab Service provides customized Jyotirlinga Darshan cab packages from Pune for devotees, families, senior citizens, and religious groups."
  },
  {
    question: "Can I customize the Jyotirlinga Darshan package?",
    answer: "Yes, the itinerary can be discussed according to your selected Jyotirlinga temples, travel dates, preferred route, stay requirements, and return schedule."
  },
  {
    question: "Are Jyotirlinga packages available for multiple days?",
    answer: "Yes, multi-day pilgrimage arrangements can be planned depending on the number of temples, route distance, sightseeing, rest periods, and accommodation schedule."
  },
  {
    question: "Is the package suitable for senior citizens?",
    answer: "Yes, private cab travel can be a convenient option for senior citizens because the journey can include planned breaks and a flexible schedule."
  },
  {
    question: "Can families book a private Jyotirlinga Darshan cab?",
    answer: "Yes, families can arrange a dedicated vehicle based on their passenger count, luggage, comfort preferences, and pilgrimage itinerary."
  },
  {
    question: "Can I choose specific Jyotirlinga temples?",
    answer: "Yes, you can share the temples you want to visit and discuss a suitable route and travel plan based on your available time."
  },
  {
    question: "Can pickup be arranged from my home in Pune?",
    answer: "Yes, pickup can be arranged from your home, hotel, office, residential society, or another preferred location in Pune."
  },
  {
    question: "Can additional religious places be added to the package?",
    answer: "Yes, additional religious or sightseeing destinations can be discussed while preparing the itinerary, depending on the route and available travel time."
  },
  {
    question: "What vehicle options are available for the pilgrimage?",
    answer: "Vehicle selection can be arranged according to the number of devotees, luggage, comfort requirements, and overall journey duration."
  },
  {
    question: "How can I book a Pune to Jyotirlinga Darshan Package?",
    answer: "Share your preferred temples, travel dates, Pune pickup location, number of devotees, vehicle preference, and approximate duration with Garud Cab Service to plan your package."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Rajendra Shinde",
    feedback: "Our family wanted to visit multiple Jyotirlinga temples from Pune and chose a private cab package. The flexible schedule was very useful for travelling with senior family members.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ashwini Kulkarni",
    feedback: "We planned a multi-day religious trip with our relatives. Having dedicated transportation made it easier to manage the temple visits, luggage, rest stops, and overall itinerary.",
    rating: 5
  }
];









  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Jyotirlinga Darshan Package",
  "image": "https://garudcabs.com/assets/images/pune-to-jyotirlinga-darshan-package.webp",
  "description": "Plan a comfortable Pune to Jyotirlinga Darshan Package with Garud Cab for a convenient pilgrimage journey across Maharashtra. Get reliable cab and taxi services for Panch Jyotirlinga and 3 Jyotirlinga tours from Pune with Sedan, Ertiga, SUV, Innova, and Innova Crysta options, suitable for families, senior citizens, and groups.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/pune-to-jyotirlinga-darshan-package"
  }
};




  return (
    <div>

<Helmet>
  <title>Pune to Jyotirlinga Darshan Package | Cab Tour | +91 9970007784</title>

  <meta
    name="description"
    content="Book a Pune to Jyotirlinga Darshan Package with Garud Cab for a comfortable Maharashtra pilgrimage tour. Get Panch Jyotirlinga and 3 Jyotirlinga darshan cab services from Pune with Sedan, Ertiga, SUV, Innova, and Innova Crysta options."
  />

  <meta
    name="keywords"
    content="Panch Jyotirlinga tour from Pune, Panch Jyotirlinga Darshan from Pune, Pune Jyotirlinga Darshan, 3 Jyotirlinga in Maharashtra tour package, 3 Jyotirlinga in Maharashtra tour package from Pune, Maharashtra 5 Jyotirlinga Darshan, Pune to Bhimashankar Jyotirlinga cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/18.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetojyotilingadarshanpackage;